import React from 'react';

function FooterTemplate() {
    return  <div className='footer__footer'>
                <div className='container'>
                    Mono 2019
                </div>
            </div>
}

export default FooterTemplate;
